import { Component, inject, OnDestroy } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ConnectionService } from '../../services/connection.service';
import { Subscription } from 'rxjs';

/**
 * Standalone Verbindungs-Status-Indikator.
 * Zeigt Wi-Fi-Icon (online) oder Wi-Fi-Off-Icon (offline).
 */
@Component({
	selector: 'wd-connection-status',
	standalone: true,
	imports: [NgbTooltipModule],
	template: `
		<button class="btn btn-status" placement="start"
			[ngbTooltip]="isOnline ? 'Internetverbindung aktiv' : 'Kein Internet!'"
			tooltipClass="custom-tooltip-class">
			@if (isOnline) {
				<div><i class="bi bi-wifi"></i></div>
			} @else {
				<i class="bi bi-wifi-off" style="color: red"></i>
			}
		</button>
	`,
	styles: [`.btn-status { padding-left: 0.1rem; border-style: none; }`]
})
export class WdConnectionStatusComponent implements OnDestroy {
	isOnline = navigator.onLine;
	private sub: Subscription;

	constructor() {
		const cs = inject(ConnectionService);
		this.sub = cs.monitor().subscribe(online => this.isOnline = online);
	}

	ngOnDestroy() { this.sub.unsubscribe(); }
}
